import { render } from "./ProformaPage.vue?vue&type=template&id=1fbedb74&scoped=true"
import script from "./ProformaPage.vue?vue&type=script&lang=js"
export * from "./ProformaPage.vue?vue&type=script&lang=js"

import "./ProformaPage.vue?vue&type=style&index=0&id=1fbedb74&scoped=true&lang=css"
import "./ProformaPage.vue?vue&type=style&index=1&id=1fbedb74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbedb74"]])

export default __exports__